import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import App from '../App';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

const AppRouter: React.FC = () => {
  const location = useLocation();
  const pathLang = location.pathname.split('/')[1];
  
  // Default language for redirects
  const defaultLang = 'en';
  
  return (
    <Routes>
      {/* Redirect root to default language */}
      <Route path="/" element={<Navigate to={`/${defaultLang}`} replace />} />
      
      {/* Language-specific routes */}
      <Route path="/en" element={<App />} />
      <Route path="/zh" element={<App />} />
      <Route path="/es" element={<App />} />
      <Route path="/fr" element={<App />} />
      <Route path="/de" element={<App />} />
      <Route path="/ja" element={<App />} />
      <Route path="/ru" element={<App />} />
      <Route path="/ar" element={<App />} />
      <Route path="/mn" element={<App />} />
      <Route path="/zh-tw" element={<App />} />
      <Route path="/zh-hk" element={<App />} />
      
      {/* Legal pages - language-specific */}
      <Route path="/en/privacy" element={<PrivacyPolicy />} />
      <Route path="/zh/privacy" element={<PrivacyPolicy />} />
      <Route path="/es/privacy" element={<PrivacyPolicy />} />
      <Route path="/fr/privacy" element={<PrivacyPolicy />} />
      <Route path="/de/privacy" element={<PrivacyPolicy />} />
      <Route path="/ja/privacy" element={<PrivacyPolicy />} />
      <Route path="/ru/privacy" element={<PrivacyPolicy />} />
      <Route path="/ar/privacy" element={<PrivacyPolicy />} />
      <Route path="/mn/privacy" element={<PrivacyPolicy />} />
      <Route path="/zh-tw/privacy" element={<PrivacyPolicy />} />
      <Route path="/zh-hk/privacy" element={<PrivacyPolicy />} />
      
      <Route path="/en/terms" element={<TermsOfService />} />
      <Route path="/zh/terms" element={<TermsOfService />} />
      <Route path="/es/terms" element={<TermsOfService />} />
      <Route path="/fr/terms" element={<TermsOfService />} />
      <Route path="/de/terms" element={<TermsOfService />} />
      <Route path="/ja/terms" element={<TermsOfService />} />
      <Route path="/ru/terms" element={<TermsOfService />} />
      <Route path="/ar/terms" element={<TermsOfService />} />
      <Route path="/mn/terms" element={<TermsOfService />} />
      <Route path="/zh-tw/terms" element={<TermsOfService />} />
      <Route path="/zh-hk/terms" element={<TermsOfService />} />
      
      {/* Legacy routes for legal pages */}
      <Route path="/privacy" element={<Navigate to="/en/privacy" replace />} />
      <Route path="/terms" element={<Navigate to="/en/terms" replace />} />
      
      {/* Catch all other routes and redirect to default language */}
      <Route path="*" element={<Navigate to={`/${defaultLang}`} replace />} />
    </Routes>
  );
};

export default AppRouter;